import { render, staticRenderFns } from "./answers-customers.vue?vue&type=template&id=2ce2a271"
import script from "./answers-customers.vue?vue&type=script&lang=js"
export * from "./answers-customers.vue?vue&type=script&lang=js"
import style0 from "./answers-customers.vue?vue&type=style&index=0&id=2ce2a271&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports